import React from "react";
import CloseIcon from "./icons/close";

import { Button, Modal, Space } from "antd";
import styles from "./styles/style.css";

export default function DeleteModal({
  isOpen,
  onClose,
  label,
  onConfirm,
  text,
  loading = false,
}) {
    console.log("isOpen", isOpen)
  return (
    <Modal
      className="confirm-modal"
      title={
        <Space direction="vertical">
          <h3 className={styles.title}>{label}</h3>
          <p className={styles.text}>{text}</p>
        </Space>
      }
      closeIcon={<CloseIcon size={14} />}
      centered
      footer={
        <Space style={{ display: "flex" }}>
            <Button
            loading={loading}
            type="primary"
            danger
            size="large"
            className={styles.delete_btn}
            onClick={onConfirm}
          >
            Delete
          </Button>
          <Button
            size="large"
            type="default"
            className="btn outline-danger-btn"
            onClick={onClose}
          >
            Cancel
          </Button>
        </Space>
      }

      open={isOpen}
      onCancel={onClose}
    ></Modal>
  );
}


